<div class="data-table-wrapper">
  <table class="data-table">
    <thead>
      <tr>
        <th>Nome</th>
        <th>E-mail</th>
        <th>Username</th>
        <th>Perfil</th>
        <th>Estado</th>
        <th class="col-acoes">Ações</th>
      </tr>
    </thead>

    <tbody>
      <!-- skeleton rows enquanto carrega -->
      <ng-container *ngIf="skeletonLoading">
        <tr *ngFor="let _ of skeletonRows">
          <td colspan="6">
            <p-skeleton height="2rem"></p-skeleton>
          </td>
        </tr>
      </ng-container>

      <!-- sem resultados -->
      <tr
        *ngIf="
          !skeletonLoading &&
          (!pagination?.data || pagination.data.length === 0)
        "
      >
        <td colspan="6" class="empty-row">
          <i
            class="pi pi-users"
            style="font-size: 2rem; display: block; margin-bottom: 8px"
          ></i>
          Nenhum utilizador encontrado
        </td>
      </tr>

      <!-- dados reais -->
      <ng-container *ngIf="!skeletonLoading">
        <tr *ngFor="let user of pagination?.data">
          <!-- coluna Nome -->
          <td>
            <div class="table-user">
              <div class="table-avatar" [ngClass]="getAvatarColor(user.id)">
                <img
                  *ngIf="showFoto(user)"
                  [src]="user.fotografia"
                  [alt]="user.nome"
                  class="table-avatar-img"
                  (error)="onFotoError(user)"
                />
                <span *ngIf="!showFoto(user)">{{ getInitials(user.nome) }}</span>
              </div>
              <span class="table-user-nome">{{ user.nome || "—" }}</span>
            </div>
          </td>
  
          <!-- coluna E-mail -->
          <td>{{ user.email || "—" }}</td>
  
          <!-- coluna Username -->
          <td>{{ user.userName || "—" }}</td>
  
          <!-- coluna Perfil -->
          <td>
            <span
              class="perfil-badge"
              [ngClass]="getPerfilBadge(user.tipoPerfil).classe"
            >
              {{ getPerfilBadge(user.tipoPerfil).label }}
            </span>
          </td>
  
          <!-- coluna Estado -->
          <td>
            <span
              class="status-badge"
              [ngClass]="getEstadoBadge(user.isActive).classe"
            >
              <i
                class="pi"
                [ngClass]="user.isActive === false ? 'pi-ban' : 'pi-check-circle'"
              ></i>
              {{ getEstadoBadge(user.isActive).label }}
            </span>
          </td>
  
          <!-- coluna Ações -->
          <td class="col-acoes">
            <p-menu
              #rowMenu
              [model]="menuItemsMap.get(user.id) ?? []"
              [popup]="true"
              appendTo="body"
              styleClass="sp-row-menu"
            ></p-menu>
            <button
              type="button"
              class="btn-icon-action"
              aria-label="Ações do utilizador"
              (click)="rowMenu.toggle($event); $event.stopPropagation()"
            >
              <i class="pi pi-ellipsis-v"></i>
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<br />

<!-- Paginação -->
<p-paginator
  *ngIf="!skeletonLoading"
  appendTo="body"
  [alwaysShow]="true"
  [rows]="pagination?.pageSize ?? 10"
  [totalRecords]="pagination?.totalRecords ?? 0"
  [rowsPerPageOptions]="[10, 20, 50]"
  [first]="((pagination?.pageNumber ?? 1) - 1) * (pagination?.pageSize ?? 10)"
  (onPageChange)="onPageChange($event)"
  styleClass="sp-paginator"
></p-paginator>
